export function shouldShowFlightMapHeader(showHeader?: boolean): boolean {
  return showHeader !== false;
}
